import { apiSlice } from '../app/api/apiSlice';
import queryString from 'query-string';
import { updateStrategyTypes } from '../store/slices/strategyType/strategyTypes';

export const strategyTypesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllStrategyTypes: builder.query({
      query: (params) => `swarms/strategy-type${params ? `?${queryString.stringify(params)}` : ''}`,
      providesTags: ['StrategyTypes'],
      keepUnusedDataFor: 1200, // Cache for 20 minutes
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(updateStrategyTypes(data));
        } catch (error) {
          if (error.status === 401) return; // Ignore 401 errors
          throw error;
        }
      },
    }),

    getStrategyTypeById: builder.query({
      query: (id) => `strategyTypes/${id}`,
      providesTags: (result, error, id) => [{ type: 'StrategyTypes', id }],
    }),

    createStrategyType: builder.mutation({
      query: (strategyType) => ({
        url: 'strategyTypes',
        method: 'POST',
        body: strategyType,
      }),
      invalidatesTags: ['StrategyTypes'],
    }),

    updateStrategyType: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `strategyTypes/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'StrategyTypes', id }],
    }),

    deleteStrategyType: builder.mutation({
      query: (id) => ({
        url: `strategyTypes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['StrategyTypes'],
    }),
  }),
});

export const {
  useGetAllStrategyTypesQuery,
  useGetStrategyTypeByIdQuery,
  useCreateStrategyTypeMutation,
  useUpdateStrategyTypeMutation,
  useDeleteStrategyTypeMutation,
} = strategyTypesApi;
